import { httpClient } from '~/utils/axios'

export const state = () => ({
  payment_links: [],
  current: null,
})

export const mutations = {
  SET_LIST(state, data) {
    state.payment_links = data
  },
  SET_CURRENT(state, data) {
    state.current = data
  },
}

export const actions = {
  async fetchList({ commit }, params = {}) {
    const res = await httpClient.get('/cmp/floor/payment_links.json', { params })
    if (res.data.status === 'success') {
      commit('SET_LIST', res.data.data.payment_links)
    }
    return res.data
  },
  async fetchOne({ commit }, uid) {
    const res = await httpClient.get(`/cmp/floor/payment_links/${uid}.json`)
    if (res.data.status === 'success') {
      commit('SET_CURRENT', res.data.data.payment_link)
    }
    return res.data
  },
  async create({ dispatch }, payload) {
    const res = await httpClient.post('/cmp/floor/payment_links.json', payload)
    return res.data
  },
  async update({ dispatch }, { uid, ...payload }) {
    const res = await httpClient.put(`/cmp/floor/payment_links/${uid}.json`, payload)
    return res.data
  },
  async updateStatus({ dispatch }, { uid, status }) {
    const res = await httpClient.put(`/cmp/floor/payment_links/${uid}/update_status.json`, { status })
    return res.data
  },
}
